export default "__VITE_ASSET__DMhCT3C3__"